import Vue from 'vue'
Vue.mixin({
    data() {
        return {
            cookieSet: this.getCookie('agecookies'),
            header: true,
            footer: true,
            fullscreen: false,
            scroll: false,
            notontop: false,
        }
    },
}) 